// extracted by mini-css-extract-plugin
export default {"header":"styles_header__NyX8e","header__headline":"styles_header__headline__0eAY9","header__new-chat-btn":"styles_header__new-chat-btn__iu0-3"};